import { Command, CommandResult } from '@/_core/cqrs/types/commands';

export class ChangeCardColor extends Command<CommandResult> {
    public BoardActivity: any;

    public constructor(
        public Id: string,
        public StorymapId: string,
        public CardType: number,
        public CardColor: number /*
        public CardColorOldValue: string,
        public CardColorLabel: string,
        public CardColorLabelOldValue: string
        */
    ) {
        super('ChangeCardColor');
    }
}
